import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core'
import {
  fetchSingleFilledEventData,
  fetchSingleEventData,
  clearEventData,
  clearFilledEventData,
  fetchEventList,
} from 'reducers/logbook/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import { LOGBOOK_DAILY } from 'constants/requestTypes'
import StatusIcon, {
  STATUS_TYPE_BASE,
  STATUS_TYPE_IN_PROGRESS,
  STATUS_TYPE_COMPLETE,
} from './StatusIcon'
import QuestionForm from './QuestionForm'
import MultiLocusQuestionForm from './MultiLocusQuestionForm'

class Questionnaire extends Component {
  state = {
    activePanel: null,
  }

  componentDidMount() {
    const { activeSite, activeDate, fetchEventList } = this.props

    if (activeSite) {
      fetchEventList({
        type: LOGBOOK_DAILY,
        site: activeSite,
        date: activeDate.local().format('YYYY-MM-DD'),
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { activeSite, activeDate, fetchEventList } = this.props

    if (
      prevProps.activeSite !== activeSite ||
      prevProps.activeDate !== activeDate
    ) {
      fetchEventList({
        type: LOGBOOK_DAILY,
        site: activeSite,
        date: activeDate.local().format('YYYY-MM-DD'),
      })

      this.setState({ activePanel: null })
    }
  }

  onExpansionChange = ({ id, values }) => (event, isExpanded) => {
    const { clearEventData, clearFilledEventData } = this.props

    clearEventData()
    clearFilledEventData()

    if (!isExpanded) {
      this.setState({
        activePanel: null,
      })

      return
    }

    if (values) {
      this.setState({
        activePanel: id,
      })

      return
    }

    this.setState({
      activePanel: id,
    })
  }

  getStatusIconByEvent = ({ evt_logbook_id, values }) => {
    let iconType = STATUS_TYPE_BASE

    if (evt_logbook_id) {
      iconType = STATUS_TYPE_COMPLETE
    }

    if (values) {
      let isValHasNull = false
      let isValHasNotNull = false

      for (const index in values) {
        if (Object.prototype.hasOwnProperty.call(values, index)) {
          const { evt_logbook_id } = values[index]

          if (!evt_logbook_id) {
            isValHasNull = true
          } else {
            isValHasNotNull = true
          }

          if (isValHasNull && isValHasNotNull) {
            iconType = STATUS_TYPE_IN_PROGRESS
            break
          }
        }
      }

      if (!isValHasNull && isValHasNotNull) {
        iconType = STATUS_TYPE_COMPLETE
      }
    }

    return <StatusIcon type={iconType} />
  }

  render() {
    const { activeSite, activeDate, logbookData, eventLoader } = this.props
    const { events } = logbookData.toJS()
    const { activePanel } = this.state

    return (
      <div className="questionnaire">
        {events.map((event, index) => (
          <ExpansionPanel
            square
            key={event.id}
            onChange={this.onExpansionChange(event)}
            expanded={activePanel === event.id}
            className="question-item">
            <ExpansionPanelSummary
              expandIcon={this.getStatusIconByEvent(event)}>
              <Typography variant="h5">{event.title}</Typography>
            </ExpansionPanelSummary>
            {Boolean(activePanel === event.id) && (
              <ExpansionPanelDetails className="question-form">
                <CircleLoader loading={eventLoader} />
                {!Object.prototype.hasOwnProperty.call(event, 'values') && (
                  <QuestionForm
                    activeSite={activeSite}
                    activeDate={activeDate.local()}
                    event={{
                      eventIndex: index,
                      ...event,
                    }}
                  />
                )}
                {Object.prototype.hasOwnProperty.call(event, 'values') && (
                  <MultiLocusQuestionForm
                    activeSite={activeSite}
                    activeDate={activeDate.local()}
                    event={{
                      eventIndex: index,
                      ...event,
                    }}
                  />
                )}
              </ExpansionPanelDetails>
            )}
          </ExpansionPanel>
        ))}
      </div>
    )
  }
}

export default connect(
  state => ({
    eventLoader: state.getIn(['logbook', 'singleEventLoader']),
    logbookData: state.getIn(['logbook', 'dailyEvents']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
  }),
  {
    fetchEventList,
    fetchSingleFilledEventData,
    fetchSingleEventData,
    clearEventData,
    clearFilledEventData,
  },
)(Questionnaire)
